import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=72d8fac0&scoped=true"
import script from "./TemplateCard.vue?vue&type=script&lang=ts"
export * from "./TemplateCard.vue?vue&type=script&lang=ts"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&id=72d8fac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d8fac0",
  null
  
)

export default component.exports